module.exports = __webpack_public_path__ + "static/media/036.3dac156e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/036.jpg
// module id = 332
// module chunks = 0